/**
 * Navigation breakpoints.
 */
const breakpoints = {
	xs: 480,
	sm: 769,
	md: 992,
	lg: 1200,
};

export default breakpoints;
